import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "string-array",
  styleUrls: ["./string-array.component.css"],
  templateUrl: "./string-array.component.html"
})
export class StringArrayComponent {
  @Input() public value: string[] = [];
  @Output() valueChange = new EventEmitter<string[]>();

  public deleteValue(entry: string) {
    console.log("delete value : " + entry);
    const index = this.value.indexOf(entry, 0);
    if (index > -1) {
      this.value.splice(index, 1);
      this.valueChange.emit(this.value);
    }
  }
}